import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const MemberBillingSettingsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "MemberBillingSettingsPage" */ "@circle-react/components/SettingsApp/MemberBilling"
    ),
);

export const MemberBillingSettingsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <MemberBillingSettingsComponent />
  </Suspense>
);
